'use client';

import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { NewsCoverHeight } from '@fe-news/constants/cover';
import { styled } from '@linaria/react';
import Image from 'next/image';
import type { FC } from 'react';
import { memo } from 'react';

const ImageContainer = styled.div`
  position: relative;
  height: ${NewsCoverHeight.DESKTOP}px;
  width: 100%;
  overflow: hidden;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    height: ${NewsCoverHeight.TABLET}px;
  }

  @media screen and (max-width: ${SCREEN_SIZE.MOBILE}px) {
    height: ${NewsCoverHeight.MOBILE}px;
  }
`;

const CoverImage = styled(Image)`
  object-fit: cover;
  border-radius: 6px;
`;

const Caption = styled.figcaption`
  font-size: 12px;
  color: #909090;
  margin-top: 8px;

  &::before {
    content: '▲';
    margin-right: 4px;
  }
`;

interface INewsCoverImageProps {
  coverSrc: string;
  coverCaption: string;
}

const NewsCoverImage: FC<INewsCoverImageProps> = ({ coverSrc, coverCaption }) => {
  if (!coverSrc) return null;

  return (
    <figure>
      <ImageContainer>
        <CoverImage
          priority
          alt='cover image of news article'
          src={coverSrc}
          fill
          sizes={`
            (max-width: ${SCREEN_SIZE.DESKTOP}px) ${NewsCoverHeight.TABLET}px,
            (max-width: ${SCREEN_SIZE.MOBILE}px) ${NewsCoverHeight.MOBILE}px
          `}
          unoptimized
        />
      </ImageContainer>
      <Caption>{coverCaption}</Caption>
    </figure>
  );
};

export default memo(NewsCoverImage);
